module.exports = __webpack_public_path__ + "assets/img/rightMenu4.e22925d4.png";